<div class="form__container">
  <form [formGroup]="form" class="dynamic-form" (keydown.enter)="$event.preventDefault()">
    @if (showOptionButtons) {
      <div class="btns-cover">
        <button mat-raised-button (click)="accordion.openAll(); isAllCollapsed.emit(false)">Expand All</button>
        <button mat-raised-button (click)="accordion.closeAll(); isAllCollapsed.emit(true)">Collapse All</button>
      </div>
    }
    <mat-accordion #dynaForm class="example-headers-align" multi>
      @for (field of fields; track field; let i = $index) {
        <mat-expansion-panel [id]="field.sectionName" class="panel" >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="sectionName">{{field.sectionName}}</span>
              <span class="sectionName-helpText">{{helpTextForSections[field.sectionName]?helpTextForSections[field.sectionName]:''}}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="column" fxLayoutAlign="start strech" fxLayout.xs="column" fxLayout.sm="column" >
            <div class="c-column" fxLayoutAlign="space-between" fxLayout="row wrap" fxLayout.xs="column" fxLayout.sm="column" >
              @for (key of field.values; track key; let j = $index) {
                <div fxFlex="100" fxLayout.xs="column" fxLayout.sm="column" >
                  @if (key.type==='CheckBox') {
                    <div class="scrollbar">
                      <ng-container appOrderDynamic [field]="key" [group]="form.get(field.sectionName)['controls'][j]" [groups]="form.controls[field.sectionName]"
                        [parentOrderForm]="parentOrderForm" [accountPreferences]="orderFormPreferences">
                      </ng-container>
                    </div>
                  }
                </div>
              }
              @for (key of field.values; track key; let j = $index) {
                <div [id]="key.labelCode" fxFlex="45" fxFlex.xs="100" fxFlex.sm="85" fxLayout.xs="column" fxLayout.sm="column">
                  @if (key.type!=='CheckBox') {
                    <div >
                      <ng-container appOrderDynamic (selectValueChange)="valueChanges($event)" [field]="key" [group]="form.get(field.sectionName)['controls'][j]" [groups]="form.controls[field.sectionName]"
                        [parentOrderForm]="parentOrderForm" [accountPreferences]="orderFormPreferences">
                      </ng-container>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="btn-cover">
            @if (!showOptionButtons) {
              <button mat-flat-button color="primary" [disabled]="form.invalid" (keyup.enter)="addSpecimenFn(field.sectionName)"
                (click)="addSpecimenFn(field.sectionName)"
              mat-raised-button>{{isEditMode ? 'Update' : 'Add'}} specimen</button>
            }
            @if (!showOptionButtons && !config.usePrePrintedLabels && hasSampleSource(field)) {
              <button mat-flat-button color="primary" [disabled]="!isSpecimenInformationValid || isEditMode" (click)="batchSpecimenFn(field.sectionName)"
              mat-raised-button class="btn-spacing">Batch select {{batchButtonName}}s</button>
            }
            @if (!showOptionButtons && isEditMode) {
              <button (keyup.enter)="isEditModeChangeFn(field.sectionName)"  (click)="isEditModeChangeFn(field.sectionName)"
              mat-button color="primary">Cancel Edit</button>
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </form>
</div>